import { useQuery } from 'react-query';
import { DocumentLinkSettingDto } from '../../../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';
import configQueryReactSimpleRequest from '../../../../config/configQuery';

const useDocumentLinkQueryFn = () =>
    getProductReservationApi().documentLinkSetting.documentLinkSettingList()
        .then((response) => response.data);

const transformDocumentLinkNames = (data: DocumentLinkSettingDto[] | null | undefined) =>
    data?.map((documentLink) => {
        return {
            ...documentLink,
            disciplineCode: {
                asiteCustomAttributeCode: documentLink.disciplineCode,
                asiteCustomAttributeName: ""

            },
            organisation: {
                asiteCustomAttributeCode: documentLink.organisation,
                asiteCustomAttributeName: ""

            },
            documentType: {
                asiteCustomAttributeCode: documentLink.documentType,
                asiteCustomAttributeName: ""

            },
            sourceDirectory: {
                workspaceName: documentLink.sourceDirectory?.split("/")[0],
                fullPath: documentLink.sourceDirectory,
            },
            linkDirectory: {
                workspaceName: documentLink.linkDirectory?.split("/")[0],
                fullPath: documentLink.linkDirectory,
            },
            status: {
                statusId: documentLink.status,
                statusName: ""
            },
            linkType: {
                id: documentLink.linkType,
                name: ""
            },
            purposeOfIssue: {
                purposeOfIssueId: documentLink.purposeOfIssue,
                name: ""
            },
            object: {
                asiteCustomAttributeCode: documentLink.object,
                asiteCustomAttributeName: ""
            },
            deelproject: {
                asiteCustomAttributeCode: documentLink.deelproject,
                asiteCustomAttributeName: ""
            },
        }
    })

const useDocumentLinkQuery = () => {
    const documentLinksQuery = useQuery(['document-links'], useDocumentLinkQueryFn, {
        ...configQueryReactSimpleRequest,
        select: (content) => transformDocumentLinkNames(content)

    });

    return documentLinksQuery;
};

export default useDocumentLinkQuery;
